import { render } from "./GeneralDynamicParametres.vue?vue&type=template&id=0b3958f6"
import script from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"
export * from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"

import "./GeneralDynamicParametres.vue?vue&type=style&index=0&id=0b3958f6&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__